.line-container {
  padding: 1.6rem 0;
  color: #8a8f98;

  &:hover {
    cursor: pointer;
    color: #cacdd5;
  }
}

.add-container {
  position: relative;
}

.add-step-container {
  position: absolute;
  display: flex;
  width: 11rem;
  padding: 0 1.1rem;
  justify-content: space-between;
  align-items: center;
  z-index: 20;
  background: var(--app-background);
  top: -0.7rem;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.add-step-text {
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.5rem;
}

.add-step-underline {
  background: currentColor;
  border-radius: 0.6rem;
  height: 0.2rem;
  width: 100%;
  z-index: 19;
}
